(function () {

const scrollShowcase = () => {

    const images = document.querySelectorAll('.scroll-showcase_item');
    const box = document.querySelector('.scroll-showcase-box');

    if (!box || !images.length) return;

    let currentImageIndex = 0;
    let lastScrollY = window.scrollY;

    const getScale = (el, fallback) => {
        const match = el.style.transform.match(/scale\(([^)]+)\)/);
        return match ? parseFloat(match[1]) : fallback;
    };

    const handleScroll = () => {

        const scrollDelta = window.scrollY - lastScrollY;

        if (Math.abs(scrollDelta) < 2) return;

        const boxRect = box.getBoundingClientRect();
        const isInViewport = boxRect.top <= 200 && boxRect.bottom > 0;

        if (!isInViewport) {
            lastScrollY = window.scrollY;
            return;
        }

        const image = images[currentImageIndex];
        if (!image) return;

        let opacity = parseFloat(getComputedStyle(image).opacity);

        if (scrollDelta > 0) {

            let scale = getScale(image, 0.8);

            opacity = Math.min(opacity + 0.07, 1);
            scale = Math.min(scale + 0.01, 1);

            image.style.opacity = opacity;
            image.style.transform = `scale(${scale})`;

            if (opacity >= 1 && currentImageIndex < images.length - 1) {
                currentImageIndex++;
            }

        } else {

            let scale = getScale(image, 1);

            opacity = Math.max(opacity - 0.07, 0);
            scale = Math.max(scale - 0.07, 0.8);

            image.style.opacity = opacity;
            image.style.transform = `scale(${scale})`;

            if (opacity <= 0 && currentImageIndex > 0) {
                currentImageIndex--;
            }
        }

        lastScrollY = window.scrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
};

document.addEventListener('DOMContentLoaded', scrollShowcase);

})();